import React from 'react'
import { ThemeProvider } from 'styled-components'
import { Link } from 'react-router-dom'
import Colors from 'builder/styles/colors'
import Button from 'builder/components/Button'
import { Icon20 } from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'
import ResumeBannerImg from './assets/resume-banner.png'
import CoachBannerImg from './assets/coaches.webm'
import {
  Container,
  BannerSection,
  ActionSection,
  Header,
  Title,
  Description,
  ImageWrapper,
  Image,
  VideoWrapper,
  Video,
  List,
  Item,
  Action,
} from './styles'

type Props = {
  title: string
  description: string
  items: string[]
  imageUrl: string
  action: React.ReactNode
  theme: {
    background: string
    text: string
  }
}

export default function ResumeCoachBanner(props: Props) {
  const [item1, item2, item3] = props.items

  return (
    <ThemeProvider theme={props.theme}>
      <Container>
        <BannerSection>
          <Header>
            <Title>{props.title}</Title>
            <Description>{props.description}</Description>
          </Header>
          {props.imageUrl.endsWith('.webm') ? (
            <VideoWrapper>
              <Video src={props.imageUrl} autoPlay muted loop playsInline />
            </VideoWrapper>
          ) : (
            <ImageWrapper>
              <Image src={props.imageUrl} />
            </ImageWrapper>
          )}
        </BannerSection>
        <ActionSection>
          <List>
            <Item>
              <Icon20.Check color={Colors.Green50} /> <span>{item1}</span>
            </Item>
            <Item>
              <Icon20.Check color={Colors.Green50} /> <span>{item2}</span>
            </Item>
            <Item>
              <Icon20.Check color={Colors.Green50} /> <span>{item3}</span>
            </Item>
            <Action>{props.action}</Action>
          </List>
        </ActionSection>
      </Container>
    </ThemeProvider>
  )
}

export const ResumeWritingBanner = () => {
  const { i18n } = useI18n()
  const translationKey = 'builder.dashboard.resume_and_coach_banners'
  const title = i18n.t(`${translationKey}.resume_writing.title`)
  const description = i18n.t(`${translationKey}.resume_writing.description`)
  const actionText = i18n.t(`${translationKey}.resume_writing.action_text`)
  const actionLink =
    'https://topresume.com/resume-writing?pt=UWYxd6Xe2VTS0&utm_content=resume_writing_services&utm_source=cio&utm_medium=ciodash&utm_campaign=tr_promo_in_ciodash'
  const items = [
    i18n.t(`${translationKey}.resume_writing.items.item1`),
    i18n.t(`${translationKey}.resume_writing.items.item2`),
    i18n.t(`${translationKey}.resume_writing.items.item3`),
  ]

  return (
    <ResumeCoachBanner
      title={title}
      description={description}
      items={items}
      imageUrl={ResumeBannerImg}
      action={
        <Button as="a" target="_blank" href={actionLink}>
          {actionText}
        </Button>
      }
      theme={{
        background: Colors.Blue10,
        text: Colors.Blue80,
      }}
    />
  )
}

export const CoachBanner = () => {
  const { i18n } = useI18n()
  const translationKey = 'builder.dashboard.resume_and_coach_banners'
  const title = i18n.t(`${translationKey}.coach.title`)
  const description = i18n.t(`${translationKey}.coach.description`)
  const actionText = i18n.t(`${translationKey}.coach.action_text`)
  const items = [
    i18n.t(`${translationKey}.coach.items.item1`),
    i18n.t(`${translationKey}.coach.items.item2`),
    i18n.t(`${translationKey}.coach.items.item3`),
  ]

  return (
    <ResumeCoachBanner
      title={title}
      description={description}
      items={items}
      imageUrl={CoachBannerImg}
      action={
        <Button as={Link} to="/career-coaching">
          {actionText}
        </Button>
      }
      theme={{
        background: Colors.Green10,
        text: Colors.Green80,
      }}
    />
  )
}
